const initialState = {
    updateOptions: [],
    updates: [],
    hasUpdates: false,
    isSelecting: false,
    selectedUpdater: '',
    saveInvoked: false,
    updatedAll: null,
    updatedIds: null,
    failedIds: null,
    showModal: false,
};

export default initialState;